<template>
  <section>
    <ul class="flex flex-col gap-y-200">
      <li v-for="{ group, numbers } of drawnNumbers" :key="group">
        <h2 class="headline-h5-headline mb-100">
          {{ $t(`results.winningnumbers.headline.${group}`) }}
        </h2>

        <LineItem
          v-bind="{ addOns, licensedTerritory, lotteryId }"
          :fields="getLotteryNumberFields(numbers)"
          highlight-add-on
          size="medium"
        />
      </li>
    </ul>
  </section>
</template>

<script lang="ts" setup>
const { addOns, drawnNumbers, licensedTerritory, lotteryId } = await useResultDetails()
</script>
